var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FF5C31"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14356_10085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0161 11.5561H15.9361C15.7321 9.72005 14.2681 8.26805 12.4441 8.06405V6.98405C12.4441 6.91205 12.3841 6.85205 12.3121 6.85205H11.6881C11.6161 6.85205 11.5561 6.91205 11.5561 6.98405V8.06405C9.72005 8.26805 8.26805 9.72005 8.06405 11.5561H6.98405C6.91205 11.5561 6.85205 11.6161 6.85205 11.6881V12.3121C6.85205 12.3841 6.91205 12.4441 6.98405 12.4441H8.06405C8.26805 14.2801 9.72005 15.7321 11.5561 15.9361V17.0161C11.5561 17.0881 11.6161 17.1481 11.6881 17.1481H12.3121C12.3841 17.1481 12.4441 17.0881 12.4441 17.0161V15.9361C14.2681 15.7321 15.7321 14.2801 15.9361 12.4441H17.0161C17.0881 12.4441 17.1481 12.3841 17.1481 12.3121V11.6881C17.1481 11.6161 17.0881 11.5561 17.0161 11.5561ZM12.0001 15.1081C10.2841 15.1081 8.89205 13.7161 8.89205 12.0001C8.89205 10.2841 10.2841 8.89205 12.0001 8.89205C13.7161 8.89205 15.1081 10.2841 15.1081 12.0001C15.1081 13.7161 13.7161 15.1081 12.0001 15.1081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 13.8356C13.0134 13.8356 13.8355 13.0136 13.8355 11.9996C13.8355 10.9856 13.0134 10.1636 11.9995 10.1636C10.9855 10.1636 10.1635 10.9856 10.1635 11.9996C10.1635 13.0136 10.9855 13.8356 11.9995 13.8356Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14356_10085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusIcon);
export default __webpack_public_path__ + "static/media/FocusIcon.dcbf0b6f9a6a5992df5a92f1caca9048.svg";
export { ForwardRef as ReactComponent };